<lib-progress-bar [progressValue]="passwordScore" [maxValue]="maxPasswordScore"></lib-progress-bar>
@if (displayFeedback && passwordFeedback.length > 0) {
  <ul class="mt-xxs small" [attr.data-qa-id]="'password-strength-feedback-list'">
    @for (feedback of passwordFeedback; track feedback) {
      @if (feedback) {
        <li [attr.data-qa-id]="'password-strength-feedback'">{{ feedback }}</li>
      }
    }
  </ul>
}
